<template>
<div class="chapter">
<div class="inner_page">
<div id="Zulu.html" xml:lang="en-GB" xmlns:xml="http://www.w3.org/XML/1998/namespace">
<div class="story">
<p class="dedication">Be the tiny blade upon the grass:<br/>
      greater than the spindle of the whole world’s mass . . .<br/>
<span class="smallcaps">—ATTILA JÓZSEF<br/></span> (translated by Zsuzsanna Ozsváth<br/>
      and Frederick Turner)<br/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Zulu.vue?1a5f6ec6